/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Divider, Grid, Space, Stepper } from "@mantine/core";
import { ValuesProvider } from "./ValuesContext";

import roomCategoryDataProvider from "./DataProvider/roomCategoryDataProvider";
import productDataProvider from "./DataProvider/productDataProvider";

import RecapCard from "./components/RecapCard";
import Step1 from "./components/StepComponents/Step1";
import Step2 from "./components/StepComponents/Step2";
import Step3 from "./components/StepComponents/Step3";
import Step4 from "./components/StepComponents/Step4";
import Step5 from "./components/StepComponents/Step5";
import Step6 from "./components/StepComponents/Step6";
import { getCategoryTitle } from "./components/StepComponents/utils";
import "./App.css";
import cureDataProvider from "./DataProvider/cureDataProvider";
import categoryCureDataProvider from "./DataProvider/categoryCureDataProvider";
import datesPriceDataProvider from "./DataProvider/datesPriceDataProvider";
import { getConstants } from "./constants";

export const ROOM_CATEGORY_NAME = "fr-FR";

const Cart = () => {
  let idCure: any;

  const location = useLocation();
  try {
    idCure = location.state.id;
  } catch (error) {
    window.location.href = "/";
  }
  const cureName = location.state.name;
  const cure = location.state.cure;
  const mews_id = location.state.mews_id;
  const date = location.state.date;
  const nbNight = location.state.nbNight;
  const curePrice = location.state.price;
  const Hotel = location.state.Hotel;
  const Hotel_id = location.state.Hotel_id;

  const [active, setActive] = useState(0);
  const [highestStepVisited, setHighestStepVisited] = useState(active);

  const initialValues = {
    CureName: cureName,
    Price: curePrice,
    Description: cure,
    Hotel: Hotel,
    Hotel_id: Hotel.id,
    Discount: 0,
    discountmews: "",
    Step1: {
      NbCuriste: "",
      Accompagnant: 0,
      Label: "",
      Description: "",
    },
    Step2: {
      Value: "",
      CureName: "",
      Mews_id: "",
      Price: 0,
    },
    Step3: {
      RequestedCategoryId: "",
      RoomName: "",
      Price: [],
      selectedRoom: {}
    },
    Restauration: {
      ProductId: "",
      ProductName: "",
      ProductPrice: 0,
      ChargingMode: "",
    },
    Step6: {
      idCustomer: "",
      confirmationMessage: ""
    },
    AdditionalProducts: [],
    AdditionalProductsPrice: 0,
    Date: {
      StartUtc: date[0],
      EndUtc: date[1],
    },
    CurePrice: curePrice,
    TotalPrice: curePrice,
    IdCure: idCure,
    Mews_id: mews_id,
    nbNight: nbNight
  };

  const [roomData, setRoomData] = useState<any>([]);
  const [mydiscount, setDiscount] = useState<any>([]);
  const [discountmews, setdiscountmews] = useState<any>([]);
  const [finish, setFinish] = useState<boolean>(false);
  const [productData, setProductData] = useState<any>([]);

  const [cureList, setCureList] = useState<any[]>([]);
  const [category, setCategory] = useState<any[]>([]);
  const [cureOption, setCureOption] = useState<any[]>([]);
  const [roomCategoryPrice, setRoomCategoryPrice] = useState<any>();
  const [allProduct, setAllProduct] = useState<any[]>([]);

  // Produits (défaut)
  const [Petitdej, setPetitdej] = useState<any>();
  const [Repas, setRepas] = useState<any>();
  // Produits (promo)
  const [PromoPetitdej, setPromoPetitdej] = useState<any>();
  const [PromoRepas, setPromoRepas] = useState<any>();

  // IDs promo détectés
  const [promoBreakfastId, setPromoBreakfastId] = useState<string | null>(null);
  const [promoMealId, setPromoMealId] = useState<string | null>(null);

  function getDatesBetween(startDate: Date, endDate: Date) {
    let dates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  }

  // 1) Détecte une promo active ET valide en nombre de nuits
  const detectPromoIds = async () => {
    try {
      const discounts = await datesPriceDataProvider.getDiscount();
      const stayStart = new Date(initialValues.Date.StartUtc);
      const stayEnd = new Date(initialValues.Date.EndUtc);

      for (const discount of discounts.resultat) {
        if (discount.hotel_id !== Hotel_id) continue;

        const discountStart = new Date(discount.start_date);
        const discountEnd = new Date(discount.end_date);

        // chevauchement de dates
        const overlaps = discountStart <= stayEnd && discountEnd >= stayStart;

        // contrôle du nombre de nuits
        const minN = discount.min_nights;
        const maxN = discount.max_nights;
        const nightsOK =
          (minN == null || nbNight >= Number(minN)) &&
          (maxN == null || nbNight <= Number(maxN));

        if (!overlaps || !nightsOK) continue;

        // OK: on a une promo valable pour ce séjour
        setDiscount(discount.dicount_percentage);
        setdiscountmews(discount.mews_id);

        if (discount.mews_breakfast_id) setPromoBreakfastId(discount.mews_breakfast_id);
        if (discount.mews_meal_id) setPromoMealId(discount.mews_meal_id);

        break; // premier discount valide suffit
      }
    } catch (e) {
      console.error("detectPromoIds error:", e);
    }
  };



  // 2) Prix chambres + application réduction jour par jour
  const fetchRoomData = async (constants: any) => {
    try {
      const endDate = new Date(initialValues.Date.EndUtc);
      const startDate = new Date(initialValues.Date.StartUtc);

      const responses = await roomCategoryDataProvider.getAvailability(
        "resources",
        constants.Service_Id,
        initialValues.Date.StartUtc,
        endDate.toString(),
        constants
      );

      const rooms = await datesPriceDataProvider.getAllRoomCategory("allRoom");
      const updatedResponses: any[] = [];

      endDate.setDate(endDate.getDate() - 1);

      for (const response of responses) {
        const myroom = rooms.resultat.find(
          (room: any) => room.mews_id.trim() === response.Id
        );

        if (!myroom) continue;

        let price = await datesPriceDataProvider.getPriceByDate(
          "datePrice",
          myroom.id,
          initialValues.Date.StartUtc,
          endDate.toString(),
          idCure
        );
        price = price[0];

        const discounts = await datesPriceDataProvider.getDiscount();

        discounts.resultat.forEach((discount: any) => {
          if (discount.hotel_id !== Hotel_id) return;

          const discountStart = new Date(discount.start_date);
          const discountEnd = new Date(discount.end_date);

          const overlaps = discountStart <= endDate && discountEnd >= startDate;

          // ✅ contrôle du nombre de nuits
          const minN = discount.min_nights;
          const maxN = discount.max_nights;
          const nightsOK =
            (minN == null || nbNight >= Number(minN)) &&
            (maxN == null || nbNight <= Number(maxN));

          if (!overlaps || !nightsOK) return;

          const discountDates = getDatesBetween(discountStart, discountEnd);
          const stayDates = getDatesBetween(startDate, endDate);

          stayDates.forEach((stayDate, index) => {
            if (discountDates.some((d) => d.toDateString() === stayDate.toDateString())) {
              const k = (1 - discount.dicount_percentage / 100);
              if (price.prices_single[index] != null) {
                price.prices_single[index] = Number(price.prices_single[index]) * k;
              }
              if (price.price_two_curists[index] != null) {
                price.price_two_curists[index] = Number(price.price_two_curists[index]) * k;
              }
              if (price.price_curist_companion[index] != null) {
                price.price_curist_companion[index] = Number(price.price_curist_companion[index]) * k;
              }
            }
          });
        });


        updatedResponses.push({ ...response, price });
      }

      setRoomData(updatedResponses);
    } catch (error) {
      console.error("Error fetching room data: ", error);
    }
  };

  // 3) Produits (toutes les fiches existantes côté Mews qui sont en BDD)
  const fetchProductData = async (constants: any) => {
    try {
      const productResponse = await productDataProvider.getProduct(
        "product",
        constants.Service_Id,
        constants
      );
      const myproducts = await productDataProvider.getAllProductsBL("allProduct");

      const updatedResponses: any[] = [];

      for (const product of myproducts.resultat) {
        for (const response of productResponse.Products) {
          if (product.mews_id.trim() !== response.Id) continue;

          if (response.ImageIds?.[0]) {
            const myImage = await roomCategoryDataProvider.getImage(
              response.ImageIds[0],
              constants
            );
            response.imageUrl = myImage.ImageUrls?.[0]?.Url;
          }
          updatedResponses.push(response);
        }
      }

      setProductData(updatedResponses);
    } catch (error) {
      console.log(error);
    }
  };

  let room_cat_id = 1;

  // 4) Données annexes + récupérer les 4 produits (défaut + promo)
  const fetchData = async (constants: any) => {
    try {
      const [
        curesResponse,
        categoryResponse,
        cureOptionResponse,
        roomCategoyResponse,
        productListResponse
      ] = await Promise.all([
        cureDataProvider.getCureList("cures"),
        categoryCureDataProvider.getCategoryNight("nights"),
        cureDataProvider.getCureOption("option"),
        datesPriceDataProvider.getPriceByRoomCategory("roomPrice", room_cat_id),
        productDataProvider.getProduct("product", constants.Service_Id, constants)
      ]);

      const filteredCures = curesResponse.resultat.filter(
        (cure: any) => cure.nights === nbNight && cure.hotel_id == Hotel_id
      );

      setCureList(filteredCures);
      setCategory(categoryResponse.resultat);
      setCureOption(cureOptionResponse.resultat);
      setRoomCategoryPrice(roomCategoyResponse.base_rate);
      setAllProduct(productListResponse.Products);

      // Défaut
      setPetitdej(productListResponse.Products.find((item: any) => item.Id === constants.petit_dejeuner_id));
      setRepas(productListResponse.Products.find((item: any) => item.Id === constants.repas_id));

      // Promo (si IDs présents)
      if (promoBreakfastId) {
        setPromoPetitdej(productListResponse.Products.find((item: any) => item.Id === promoBreakfastId));
      } else {
        setPromoPetitdej(undefined);
      }
      if (promoMealId) {
        setPromoRepas(productListResponse.Products.find((item: any) => item.Id === promoMealId));
      } else {
        setPromoRepas(undefined);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 5) Orchestration
  useEffect(() => {
    (async () => {
      const constants = getConstants(Hotel_id);
      await detectPromoIds(); // détecte et set les IDs promo
      await Promise.all([
        fetchRoomData(constants),
        fetchProductData(constants),
      ]);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Quand les IDs promo sont connus, on charge les 4 produits
  useEffect(() => {
    const constants = getConstants(Hotel_id);
    fetchData(constants);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promoBreakfastId, promoMealId]);

  const matchingDataAndCureOption = cureList.map((dataItem: any) => {
    const matchedCureOption = cureOption.filter(
      (cureOptionItem: any) => cureOptionItem.id === dataItem.id
    );
    const matchedcategoryNight = category.filter(
      (categoryItem: any) => categoryItem.id === dataItem.category_id
    );
    const category_title = getCategoryTitle(matchedcategoryNight);

    const priceCure = allProduct.find(
      (product: any) => product.Id === dataItem.mews_id
    );

    if (priceCure) {
      const minPrice = priceCure.Pricing.Value.GrossValue;

      return {
        ...dataItem,
        ...matchedCureOption,
        category_title,
        minPrice:
          minPrice !== 0
            ? minPrice
            : (roomCategoryPrice * nbNight).toFixed(),
      };
    }
  });

  const handleStepChange = useCallback((nextStep: number) => {
    if (nextStep === 9) {
      setHighestStepVisited(1);
      return;
    } else if (nextStep > 5 || nextStep < 0) {
      return;
    }

    setActive(nextStep);
    setHighestStepVisited((hSC) => Math.max(hSC, nextStep));
  }, []);

  const shouldAllowSelectStep = (step: number) => {
    if (finish === true) {
      return false;
    }
    return highestStepVisited >= step && active !== step;
  };

  return (
    <>
      <ValuesProvider initialValues={initialValues}>
        <Divider my="sm" />
        <Container size="xl" px="xl">
          <Space h="xl" />
          <Space h="xl" />
          <Grid>
            <Grid.Col xl={4} md={4} lg={4}>
              <RecapCard
                date={date}
                nbNight={nbNight}
                active={active}
                discount={mydiscount}
              />
            </Grid.Col>
            <Grid.Col xl={8} md={8} lg={8}>
              <Stepper
                color="var(--main-color)"
                active={active}
                onStepClick={setActive}
                breakpoint="sm"
                size="sm"
              >
                <Stepper.Step
                  className={
                    active === 0
                      ? "stepper-block-active"
                      : "stepper-block-inline"
                  }
                  label="participants"
                  allowStepSelect={shouldAllowSelectStep(0)}
                >
                  <Step1
                    active={active}
                    initialValues={initialValues}
                    handleStepChange={handleStepChange}
                    mydiscount={mydiscount}
                    discountmews={discountmews}
                  />
                </Stepper.Step>
                <Stepper.Step
                  className={
                    active === 1
                      ? "stepper-block-active"
                      : active > 1
                        ? "stepper-block-inline"
                        : "stepper-block-inert"
                  }
                  label="programmes des soins"
                  allowStepSelect={shouldAllowSelectStep(1)}
                >
                  <Step2
                    heal={cure}
                    nbNight={nbNight}
                    idCure={idCure}
                    cureName={cureName}
                    cures={matchingDataAndCureOption}
                    active={active}
                    handleStepChange={handleStepChange}
                    Petitdej={Petitdej}
                  />
                </Stepper.Step>
                <Stepper.Step
                  className={
                    active === 2
                      ? "stepper-block-active"
                      : active > 2
                        ? "stepper-block-inline"
                        : "stepper-block-inert"
                  }
                  label="votre chambre"
                  {...(Hotel_id === 1 ? { allowStepSelect: false } : { allowStepSelect: shouldAllowSelectStep(2) })}
                >
                  <Step3
                    idCure={idCure}
                    active={active}
                    nbNight={nbNight}
                    handleStepChange={handleStepChange}
                    roomData={roomData}
                  />
                </Stepper.Step>
                <Stepper.Step
                  className={
                    active === 3
                      ? "stepper-block-active"
                      : active > 3
                        ? "stepper-block-inline"
                        : "stepper-block-inert"
                  }
                  label="options & personnalisation"

                  {...(Hotel_id === 1 ? { allowStepSelect: false } : { allowStepSelect: shouldAllowSelectStep(3) })}
                >
                  <Step4
                    Petitdej={Petitdej}
                    Repas={Repas}
                    PromoPetitdej={PromoPetitdej}
                    PromoRepas={PromoRepas}
                    productData={productData}
                    active={active}
                    nbNight={nbNight}
                    handleStepChange={handleStepChange}
                    Hotel_id={Hotel_id}
                  />
                </Stepper.Step>
                <Stepper.Step
                  className={
                    active === 4
                      ? "stepper-block-active"
                      : active > 4
                        ? "stepper-block-inline"
                        : "stepper-block-inert"
                  }
                  label="récapitulatif"
                  allowStepSelect={shouldAllowSelectStep(4)}
                >
                  <Step5 active={active} night={nbNight} handleStepChange={handleStepChange} />
                </Stepper.Step>
                <Stepper.Step
                  className={
                    active === 5
                      ? "stepper-block-active"
                      : active > 5
                        ? "stepper-block-inline"
                        : "stepper-block-inert"
                  }
                  label="coordonnées"
                  allowStepSelect={shouldAllowSelectStep(5)}
                >
                  <Step6 active={active} handleStepChange={handleStepChange} setFinish={setFinish} Hotel_id={Hotel_id} />
                </Stepper.Step>
                <Stepper.Completed>
                  Completed, click back button to get to previous step
                </Stepper.Completed>
              </Stepper>
            </Grid.Col>
          </Grid>
        </Container>
      </ValuesProvider>
    </>
  );
};

export default Cart;
